import { render, staticRenderFns } from "./moreAnalytics1.vue?vue&type=template&id=3516abed&"
import script from "./moreAnalytics1.vue?vue&type=script&lang=js&"
export * from "./moreAnalytics1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3516abed')) {
      api.createRecord('3516abed', component.options)
    } else {
      api.reload('3516abed', component.options)
    }
    module.hot.accept("./moreAnalytics1.vue?vue&type=template&id=3516abed&", function () {
      api.rerender('3516abed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/moreAnalytics1.vue"
export default component.exports